import React from "react"
import CatTabItem from "./CartTabItem/CatTabItem"

type Props = {
    active: number
    urlBase: string
    tabsContent: {title: string, img: string, id:number, imgActive: string}[]
    setActive: (catId: number) => void
}

const CatTabsWraper = ({active, urlBase, tabsContent, setActive}: Props): React.ReactElement => {
	return (
		// <ul className="nav nav-tabs nav-fill">
		<ul className="list-unstyled row justify-content-between align-items-baseline mb-lg-5 pb-lg-2">
			{tabsContent.map(({title, img, id, imgActive}) =>
				<CatTabItem
					setActive={setActive}
					key={title}
					isActive={active === id}
					label={title}
					urlBase={urlBase}
					img={img}
					id={id}
					imgActive={imgActive}
				/>
			)}
		</ul>
	)
}

export default CatTabsWraper
